export type BookId =
  | 'GEN' | 'EXO' | 'LEV' | 'NUM' | 'DEU' | 'JOS' | 'JDG' | 'RUT'
  | '1SA' | '2SA' | '1KI' | '2KI' | '1CH' | '2CH' | 'EZR' | 'NEH'
  | 'EST' | 'JOB' | 'PSA' | 'PRO' | 'ECC' | 'SNG' | 'ISA' | 'JER'
  | 'LAM' | 'EZK' | 'DAN' | 'HOS' | 'JOL' | 'AMO' | 'OBA' | 'JON'
  | 'MIC' | 'NAM' | 'HAB' | 'ZEP' | 'HAG' | 'ZEC' | 'MAL'
  | 'MAT' | 'MRK' | 'LUK' | 'JHN' | 'ACT' | 'ROM' | '1CO' | '2CO'
  | 'GAL' | 'EPH' | 'PHP' | 'COL' | '1TH' | '2TH' | '1TI' | '2TI'
  | 'TIT' | 'PHM' | 'HEB' | 'JAS' | '1PE' | '2PE' | '1JN' | '2JN'
  | '3JN' | 'JUD' | 'REV';

export type Testament = 'OT' | 'NT';

export type Genre =
  | 'law' | 'history' | 'wisdom' | 'poetry'
  | 'major-prophet' | 'minor-prophet'
  | 'gospel' | 'acts' | 'pauline-epistle' | 'general-epistle' | 'apocalyptic';

export interface Book {
  id: BookId;
  name: string;
  shortName: string;
  testament: Testament;
  order: number;
  chapterCount: number;
  verseCount?: number;
  genre: Genre;
}

export interface Verse {
  book: BookId;
  chapter: number;
  verse: number;
  text: string;
  paragraph?: boolean;
  poetry?: 'q1' | 'q2';
}

export interface Chapter {
  book: BookId;
  number: number;
  verses: Verse[];
}

export interface VerseRef {
  book: BookId;
  chapter: number;
  verse: number;
}

export interface VerseRange {
  start: VerseRef;
  end: VerseRef;
}

export interface BibleManifest {
  translation: string;
  name: string;
  publicDomain: boolean;
  source: string;
  builtAt: string;
  books: Book[];
}

export function isVerseRange(r: VerseRef | VerseRange): r is VerseRange {
  return (r as VerseRange).start !== undefined;
}

export function refKey(r: VerseRef): string {
  return `${r.book}:${r.chapter}:${r.verse}`;
}
